import { Radar } from 'react-chartjs-2';
import { withChartTheme } from '../withChartTheme';

var RadarChart = withChartTheme(Radar, { defaultScales: [] });

var RadarChartDoc = void 0;
if (process.env.NODE_ENV !== 'production') {
  RadarChartDoc = require('./doc').default(RadarChart); // eslint-disable-line global-require
}

var RadarChartWrapper = RadarChartDoc || RadarChart;

export { RadarChartWrapper as RadarChart };


//////////////////
// WEBPACK FOOTER
// ./node_modules/grommet-controls/es6/components/RadarChart/RadarChart.js
// module id = 1200
// module chunks = 0